import React, { useEffect, useState } from 'react';

const Argitech4 = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [showVideo, setShowVideo] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handlePlayClick = () => {
    setShowVideo(true);
  };

  return (
    <div className='bg-white '>
      <div className='px-4 md:px-40 pt-3'>
        <h1 className="text-[14px] md:text-[36px] font-bold mt-3 text-[#FDBD26]">AgriTech</h1>
        <h1 className="text-[12px] md:text-[32px] font-bold mb-4 text-black">
          Revolutionizing Agriculture with Digital solutions
        </h1>

        <div className="relative w-full overflow-hidden rounded-lg bg-white">
          <div className="relative w-full rounded-lg">
            {isLoading && !showVideo && (
              <div className="absolute inset-0 flex items-center justify-center bg-gray-100 z-10">
                <div className="animate-spin rounded-full h-12 w-12 border-t-4 border-[#742B3E] border-solid"></div>
              </div>
            )}

            {!showVideo && (
              <img
                src="https://res.cloudinary.com/dzngpgki4/image/upload/v1743776596/image_1502_utmsek.png"
                alt="Play"
                onClick={handlePlayClick}
                className="cursor-pointer absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[40px] h-[40px] md:w-[133px] md:h-[133px] z-10"
              />
            )}

            {showVideo ? (
              <video
                controls
                autoPlay
                className="w-full md:h-[622px] object-cover rounded-lg"
              >
                <source
                  src="https://res.cloudinary.com/dzngpgki4/video/upload/v1744733749/Agriculture_Minister_sets_tone_for_his_tenure_-_nbc_bbqejf.mp4"
                  type="video/mp4"
                />
                Your browser does not support the video tag.
              </video>
            ) : (
              <img
                src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744553588/image-3_wupnyl.png"
                alt="Securing Agriculture in Namibia"
                className={`w-full md:h-[622px] object-cover rounded-lg transition-opacity duration-500 ${
                  isLoading ? 'opacity-0' : 'opacity-100'
                }`}
                onLoad={() => setIsLoading(false)}
              />
            )}

            {!isLoading && !showVideo && (
              <div className="absolute md:bottom-2 bottom-6 md:left-0 w-full px-4">
                <h2 className="text-white md:text-[24px] font-bold mb-2">FOOD SECURITY</h2>
                <h2
                  className="text-white text-[14px] md:text-[40px] font-bold -mt-3"
                  style={{ lineHeight: '1.20' }}
                >
                  Innovation for Sustainable <br /> Future
                </h2>
              </div>
            )}
          </div>
        </div>

        <div className='px-1'>
  {/* Content Section */}
  <div className="mt-5 max-w-screen-xl w-full">
    <h3 className="text-black font-normal text-[14px] md:text-[30px]">April 13, 2025</h3>
    <div className="flex items-center gap-6 md:gap-8 text-[13px] md:text-[30px] font-normal text-black">
      <p>Story by Editorial team</p>
      <div className="flex items-center gap-2 text-[#155528]">
        <img
          src="https://res.cloudinary.com/dzngpgki4/image/upload/v1743893169/Time_progress_light_ecbt3q.png"
          alt="Clock"
          className="h-6 w-6 md:h-8 md:w-8"
        />
        <p>2 Minutes read</p>
      </div>
    </div>
  </div>

  {/* Main Text Section */}
  <div className="md:mt-5 mt-2 md:space-y-7 space-y-5">
    <div className="md:mt-5 mt-2 md:space-y-10 space-y-5 text-[10px] md:text-[32px] text-black font-normal leading-tight">
      <p>
        <h3 className="text-black font-bold text-[8px] md:text-[32px] mt-3 md:mt-5 md:mb-8">
          Agriculture Minister sets tone for his tenure
        </h3>
        The Minister of Agriculture, Water, and Land Reform outlines the key priorities and directions that the minister will emphasize during their tenure.
      </p>

      <p>
        <h4 className="font-bold">Agricultural Modernization and Productivity</h4>
        The ministry has consistently highlighted the importance of modernizing agriculture to enhance productivity and ensure food security. Efforts are focused on integrating small-scale farmers, cooperatives, women, and youth into the mainstream agri-food sector. This includes promoting climate-resilient farming practices and establishing social safety nets to support vulnerable communities.
      </p>

      <p>
        <h4 className="font-bold">Investment in Green Scheme Projects</h4>
        To boost domestic food production, the ministry has been expanding green scheme projects across Namibia. For instance, at Etunda, 210 hectares of wheat were harvested, and plans are underway to plant additional hectares of maize. Similar initiatives are being implemented at Sikondo and Uvhungu Vhungu, aiming to increase agricultural output and create employment opportunities.
      </p>

      <p>
        <h4 className="font-bold">Subsidies and Support Programs for Farmers</h4>
        Recognizing the need to support farmers, especially in the face of challenges like climate change, the ministry has allocated N$62 million for subsidies. These subsidies cover various sectors, including dairy, horticulture, and poultry, aiming to reduce production costs and enhance food security. The programs are designed to empower youth, women, and previously disadvantaged groups.
      </p>

      <p>
        <h4 className="font-bold">Transformation of the Agri-Food Sector</h4>
        The ministry has launched initiatives to transform the agri-food sector, focusing on increasing agricultural productivity, ensuring food and nutrition security, promoting sustainable resource management, and creating an enabling environment with responsive institutions. These efforts are aligned with regional commitments, such as the Malabo Declaration, aiming to halve poverty and boost intra-African agricultural trade.
      </p>

      <p>
        <h4 className="font-bold">Mechanization and Food Security Initiatives</h4>
        To enhance food security, so far the ministry has procured 600 tractors to assist farmers in improving agricultural production and productivity. This mechanization effort aims to enable farmers to complete operations efficiently and timely, contributing to national food self-sufficiency.
      </p>

      <p>
        <h4 className="font-bold">Commitment to Inclusive Growth</h4>
        The minister is expected to continue emphasizing agriculture as a national priority for inclusive growth. This involves recognizing the sector's potential to create jobs, reduce poverty, and address income inequalities through land reform and empowerment opportunities. Allocating resources to boost food security and self-sufficiency remains a key focus.
      </p>

      <p>
        The minister's tenure is anticipated to focus on <strong>modernizing agriculture, supporting farmers, promoting sustainable practices, and ensuring food security</strong>. These efforts align with Namibia's broader goals of economic diversification and inclusive growth.
      </p>

      <div className="md:h-5 h-2"></div>
    </div>
  </div>
</div>

      </div>
    </div>
  );
};

export default Argitech4;
